import { useContext, useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";

// MindPlus components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// MindPlus examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import dataTableData from "layouts/library/quote-list/data/dataTableData";

import DataTable from "examples/Tables/DataTable";
import { NavLink, useParams } from "react-router-dom";
import AddQuotePopup from "layouts/library/quote-list/components/AddQuotePopup";
import { DataContext } from "context/dataContext";

function QuoteList() {
  const params = useParams();

  const [data, setData] = useState({ ...dataTableData, rows: [] });

  const { dataState, getQuotesApi } = useContext(DataContext);

  const [sessions, setQuotes] = useState([]);
  const [programName, setProgramName] = useState("");
  const [popupState, setPopupState] = useState(false);

  const addQuote = () => {
    setPopupState(true);
    console.log("Add Quote clicked");
  };

  useEffect(() => {
    console.log(dataState.all_quotes);
    setData((prevData) => ({
      ...prevData,
      rows: dataState.all_quotes.map((quote) => {
        return {
          ...quote,
        };
      }),
    }));
  }, [dataState.all_quotes]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={12}>
            <MDBox mb={2}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={6}>
                  <MDTypography variant="h4" fontWeight="medium">
                    Quotes
                  </MDTypography>
                  <MDBox mt={1}>
                    <MDTypography variant="body2" color="text">
                      Add & manage quote of the app.
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ textAlign: "right" }}>
                  <MDButton variant="gradient" color="dark" onClick={addQuote}>
                    New Quote
                  </MDButton>
                  {/* <MDButton variant="gradient" color="primary" onClick={saveProgram} sx={{ ml: 2 }}>
                    Save Program
                  </MDButton> */}
                </Grid>
              </Grid>
            </MDBox>
            <Card>
              {data.rows.length > 0 ? (
                <DataTable table={data} canSearch />
              ) : (
                <MDBox p={2}>
                  <MDTypography>No Data</MDTypography>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <AddQuotePopup open={popupState} close={setPopupState} />
      <Footer />
    </DashboardLayout>
  );
}

export default QuoteList;
